import React from 'react';
import PropTypes from 'prop-types';
import {fromJS} from 'immutable';
import Tabs from 'sg/Tabs/Tabs.react';
import {resource} from '@albert-io/json-api-framework/request/builder';
import {history} from 'client/history';
import QuestionsTable from './QuestionsTable/QuestionsTable.react';
import StandardsTable from './StandardsTable/StandardsTable.react';
import classroomV2Store from 'client/Classrooms/Classroom/ClassroomV2.store';
import {Link} from 'react-router';
import {Icon, Button} from '@albert-io/atomic';
import './student-insights.scss';

const tabs = fromJS([
  {
    label: 'Questions',
    query: {
      tab: null
    }
  },
  {
    label: 'Standards',
    query: {
      tab: 'standards'
    }
  }
]);

export default class StudentInsights extends React.Component {
  static propTypes = {
    location: PropTypes.shape({
      query: PropTypes.shape({
        attempt: PropTypes.string,
        tab: PropTypes.string
      })
    }),
    params: PropTypes.shape({
      classId: PropTypes.string,
      studentId: PropTypes.string
    })
  };

  constructor(props) {
    super(props);
    if (!this.props.location.query.attempt) {
      history.pushState(null, `/classes/${this.props.params.classId}/insights`);
    }
  }

  getStudentQuery = () => {
    return resource('student_v2').mandarkEndpoint(['students_v2', this.props.params.studentId]);
  };

  render() {
    const {classId} = this.props.params;
    const {studentId} = this.props.params;
    const searchId = this.props.location.search;
    const student = this.getStudentQuery().getResource();
    const studentName = this.getStudentQuery().isResourcePopulated() ? (
      <h1>{`${student.getFirstName()} ${student.getLastName()}`}</h1>
    ) : null;

    const nextStudent = classroomV2Store.getNextStudentAlphabetized(studentId);

    return (
      <div className='student-insights'>
        <div className='single-student-insight-view__header'>
          <div className='single-student-insight-view__student-name'>{studentName}</div>
          <div>
            {nextStudent && (
              <Button
                as={Link}
                size='s'
                color='secondary'
                icon='chevron-right'
                to={`/classes/${classId}/insights/topic-drilldown/student/${nextStudent.getId()}/${searchId}`}
              >
                Next student <Icon icon='chevron-right' className='u-mar-l_1' />
              </Button>
            )}
          </div>
        </div>
        <Tabs className='student-insights__tabs' content={tabs}>
          {this.props.location.query.tab === 'standards' ? <StandardsTable /> : <QuestionsTable />}
        </Tabs>
      </div>
    );
  }
}
